module.exports = __webpack_public_path__ + "assets/customersIcon.90709e34.svg";